import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";

export type SpacerComponentProps = RootContainerProps & {
  style: React.CSSProperties;
};

const OUTER_STYLE: React.CSSProperties = {
  width: "100%"
};
export default (props: SpacerComponentProps) => (
  <Container className="wsc_content_spacer" {...getContainerProps(props)} style={OUTER_STYLE}>
    <div className="wsc_content_spacer_inner" style={props.style}></div>
  </Container>
);
